import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetStoreServicePackageMutationVariables = Types.Exact<{
  input: Types.SetStoreServicePackageInput;
}>;


export type SetStoreServicePackageMutation = { __typename?: 'Mutation', setStoreServicePackage: boolean };


export const SetStoreServicePackageDocument = gql`
    mutation setStoreServicePackage($input: SetStoreServicePackageInput!) {
  setStoreServicePackage(input: $input)
}
    `;
export type SetStoreServicePackageMutationFn = Apollo.MutationFunction<SetStoreServicePackageMutation, SetStoreServicePackageMutationVariables>;

/**
 * __useSetStoreServicePackageMutation__
 *
 * To run a mutation, you first call `useSetStoreServicePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoreServicePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoreServicePackageMutation, { data, loading, error }] = useSetStoreServicePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStoreServicePackageMutation(baseOptions?: Apollo.MutationHookOptions<SetStoreServicePackageMutation, SetStoreServicePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStoreServicePackageMutation, SetStoreServicePackageMutationVariables>(SetStoreServicePackageDocument, options);
      }
export type SetStoreServicePackageMutationHookResult = ReturnType<typeof useSetStoreServicePackageMutation>;
export type SetStoreServicePackageMutationResult = Apollo.MutationResult<SetStoreServicePackageMutation>;
export type SetStoreServicePackageMutationOptions = Apollo.BaseMutationOptions<SetStoreServicePackageMutation, SetStoreServicePackageMutationVariables>;